/* eslint-disable comma-dangle */
/* eslint-disable arrow-parens */
import Utils from '../../Utils';

class Slider {
    constructor(data) {
        this.slider = document.querySelector('.slider');
        this.data = data;
        this.isDown = false;
        this.startX = null;
        this.posInitial = null;
        this.scroll = null;
        this.touchPosX1 = null;
        this.touchPosX2 = null;
        this.initListener();
    }

    initListener() {
        this.slider.addEventListener('mousedown', this.sliderDown.bind(this), false);
        this.slider.addEventListener('mouseup', this.sliderUp.bind(this), false);
        this.slider.addEventListener('mousemove', this.sliderMove.bind(this), false);
    }

    sliderDown(e) {
        this.isDown = true;
        this.startX = e.pageX - this.slider.offsetLeft;
        this.scroll = this.slider.scrollLeft;
        this.slider.classList.add('active');
    }

    sliderUp() {
        this.isDown = false;
        this.slider.classList.remove('active');
    }

    sliderMove(e) {
        if (!this.isDown) return;
        e.preventDefault();
        const nextPoint = e.pageX - this.slider.offsetLeft;
        const difference = (nextPoint - this.startX) * 2;
        this.slider.scrollLeft = this.scroll - difference;
    }

    render() {
        this.slider.innerHTML += this.data
            .map(
                (item) => `
                <div class='card'> <img src='${item.snippet.thumbnails.medium.url}'>
                    <div>
                      <a href='https://www.youtube.com/watch?v=${item.id}' target="_blank">${item.snippet.title}</a>
                    </div>
                    <h3>
                      <i class="fas fa-male"></i>
                       ${item.snippet.channelTitle}
                    </h3>
                    <p>
                      <i class="far fa-calendar-alt"></i>
                       ${Utils.getData(item.snippet.publishedAt)}
                    </p>
                    <p> 
                      <i class="fas fa-eye"></i>
                       ${item.statistics.viewCount}
                    </p>
                    <p>
                       ${item.snippet.description}
                    </p>
                </div>`
            )
            .join(' ');
    }
}

export default Slider;
